import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-loader',
  templateUrl: './web-loader.component.html',
  styleUrls: ['./web-loader.component.css']
})
export class WebLoaderComponent implements OnInit {

  constructor() {
    
  }

  ngOnInit() {
    
  }

}
